// extracted by mini-css-extract-plugin
module.exports = {"vertical":"FormMain_vertical__1VCJR"};